
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/sheet",
      function () {
        return require("private-next-pages/joy-ui/api/sheet.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/sheet"])
      });
    }
  